/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateMetaMcpMemberForm,
  UpdateMetaMcpMemberForm$Outbound,
  UpdateMetaMcpMemberForm$outboundSchema,
} from "../components/updatemetamcpmemberform.js";

export type UpdateMetaMcpMemberSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateMetaMcpMemberSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateMetaMcpMemberSecurity = {
  option1?: UpdateMetaMcpMemberSecurityOption1 | undefined;
  option2?: UpdateMetaMcpMemberSecurityOption2 | undefined;
};

export type UpdateMetaMcpMemberRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateMetaMcpMemberForm: UpdateMetaMcpMemberForm;
};

/** @internal */
export type UpdateMetaMcpMemberSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateMetaMcpMemberSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpMemberSecurityOption1$Outbound,
  UpdateMetaMcpMemberSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateMetaMcpMemberSecurityOption1ToJSON(
  updateMetaMcpMemberSecurityOption1: UpdateMetaMcpMemberSecurityOption1,
): string {
  return JSON.stringify(
    UpdateMetaMcpMemberSecurityOption1$outboundSchema.parse(
      updateMetaMcpMemberSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateMetaMcpMemberSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateMetaMcpMemberSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpMemberSecurityOption2$Outbound,
  UpdateMetaMcpMemberSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateMetaMcpMemberSecurityOption2ToJSON(
  updateMetaMcpMemberSecurityOption2: UpdateMetaMcpMemberSecurityOption2,
): string {
  return JSON.stringify(
    UpdateMetaMcpMemberSecurityOption2$outboundSchema.parse(
      updateMetaMcpMemberSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateMetaMcpMemberSecurity$Outbound = {
  Option1?: UpdateMetaMcpMemberSecurityOption1$Outbound | undefined;
  Option2?: UpdateMetaMcpMemberSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateMetaMcpMemberSecurity$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpMemberSecurity$Outbound,
  UpdateMetaMcpMemberSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateMetaMcpMemberSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateMetaMcpMemberSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateMetaMcpMemberSecurityToJSON(
  updateMetaMcpMemberSecurity: UpdateMetaMcpMemberSecurity,
): string {
  return JSON.stringify(
    UpdateMetaMcpMemberSecurity$outboundSchema.parse(
      updateMetaMcpMemberSecurity,
    ),
  );
}

/** @internal */
export type UpdateMetaMcpMemberRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateMetaMcpMemberForm: UpdateMetaMcpMemberForm$Outbound;
};

/** @internal */
export const UpdateMetaMcpMemberRequest$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpMemberRequest$Outbound,
  UpdateMetaMcpMemberRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateMetaMcpMemberForm: UpdateMetaMcpMemberForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateMetaMcpMemberForm: "UpdateMetaMcpMemberForm",
    });
  }),
);

export function updateMetaMcpMemberRequestToJSON(
  updateMetaMcpMemberRequest: UpdateMetaMcpMemberRequest,
): string {
  return JSON.stringify(
    UpdateMetaMcpMemberRequest$outboundSchema.parse(updateMetaMcpMemberRequest),
  );
}
